const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse = new (require('@comunica/core').Bus)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-parse/Bus/RdfParse'
});
const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_Bus_Http = new (require('@comunica/core').Bus)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-http/Bus/Http'
});
const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html_Bus_RdfParseHtml = new (require('@comunica/core').Bus)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-parse-html/Bus/RdfParseHtml'
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorRdfParseMediatypes = new (require('@comunica/mediator-combine-union').MediatorCombineUnion)({
  'field': 'mediaTypes',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#mediatorRdfParseMediatypes',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorRdfParseHandle = new (require('@comunica/mediator-race').MediatorRace)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#mediatorRdfParseHandle',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserN3 = new (require('@comunica/actor-rdf-parse-n3').ActorRdfParseN3)({
  'mediaTypes': {
  'application/n-quads': '1.0',
  'application/trig': '0.95',
  'application/n-triples': '0.8',
  'text/turtle': '0.6',
  'text/n3': '0.35'
},
  'mediaTypeFormats': {
  'application/n-quads': 'http://www.w3.org/ns/formats/N-Quads',
  'application/trig': 'http://www.w3.org/ns/formats/TriG',
  'application/n-triples': 'http://www.w3.org/ns/formats/N-Triples',
  'text/turtle': 'http://www.w3.org/ns/formats/Turtle',
  'text/n3': 'http://www.w3.org/ns/formats/N3'
},
  'priorityScale': '1',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserN3',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserRdfXml = new (require('@comunica/actor-rdf-parse-rdfxml').ActorRdfParseRdfXml)({
  'mediaTypes': {
  'application/rdf+xml': '1.0'
},
  'mediaTypeFormats': {
  'application/rdf+xml': 'http://www.w3.org/ns/formats/RDF_XML'
},
  'priorityScale': '5.0E-1',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserRdfXml',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserXmlRdfa = new (require('@comunica/actor-rdf-parse-xml-rdfa').ActorRdfParseXmlRdfa)({
  'mediaTypes': {
  'application/xml': '1.0',
  'text/xml': '1.0',
  'image/svg+xml': '1.0'
},
  'mediaTypeFormats': {
  'application/xml': 'http://www.w3.org/ns/formats/RDFa',
  'text/xml': 'http://www.w3.org/ns/formats/RDFa',
  'image/svg+xml': 'http://www.w3.org/ns/formats/RDFa'
},
  'priorityScale': '3.0E-1',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserXmlRdfa',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorHttp = new (require('@comunica/mediator-number').MediatorNumber)({
  'field': 'time',
  'type': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/mediator-number/Mediator/Number/type/TypeMin',
  'ignoreErrors': true,
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#mediatorHttp',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_Bus_Http
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myHttpFetcher = new (require('@comunica/actor-http-native').ActorHttpNative)({
  'agentOptions': '{ "keepAlive": true, "maxSockets": 5 }',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myHttpFetcher',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_Bus_Http
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtml = new (require('@comunica/actor-rdf-parse-html').ActorRdfParseHtml)({
  'busRdfParseHtml': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html_Bus_RdfParseHtml,
  'mediaTypes': {
  'text/html': '1.0',
  'application/xhtml+xml': '0.9'
},
  'mediaTypeFormats': {
  'text/html': 'http://www.w3.org/ns/formats/HTML',
  'application/xhtml+xml': 'http://www.w3.org/ns/formats/HTML'
},
  'priorityScale': '2.0E-1',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserHtml',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtmlMicrodata = new (require('@comunica/actor-rdf-parse-html-microdata').ActorRdfParseHtmlMicrodata)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserHtmlMicrodata',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html_Bus_RdfParseHtml
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtmlRdfa = new (require('@comunica/actor-rdf-parse-html-rdfa').ActorRdfParseHtmlRdfa)({
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserHtmlRdfa',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html_Bus_RdfParseHtml
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtmlScript = new (require('@comunica/actor-rdf-parse-html-script').ActorRdfParseHtmlScript)({
  'mediatorRdfParseMediatypes': https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorRdfParseMediatypes,
  'mediatorRdfParseHandle': https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorRdfParseHandle,
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserHtmlScript',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html_Bus_RdfParseHtml
});
const https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserJsonLd = new (require('@comunica/actor-rdf-parse-jsonld').ActorRdfParseJsonLd)({
  'mediatorHttp': https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorHttp,
  'mediaTypes': {
  'application/ld+json': '1.0',
  'application/json': '0.5'
},
  'mediaTypeFormats': {
  'application/ld+json': 'http://www.w3.org/ns/formats/JSON-LD',
  'application/json': 'http://www.w3.org/ns/formats/JSON-LD'
},
  'priorityScale': '9.0E-1',
  'name': 'https://linkedsoftwaredependencies.org/bundles/npm/rdf-parse/^1.0.0/config/config-default.json#myRdfParserJsonLd',
  'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_Bus_RdfParse
});
const urn_comunica_my = new (require('./index.js').RdfParser)({
  'mediatorRdfParseMediatypes': https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorRdfParseMediatypes,
  'mediatorRdfParseHandle': https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_mediatorRdfParseHandle,
  'parsers': [
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserN3,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserJsonLd,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserRdfXml,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserXmlRdfa,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtml,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtmlMicrodata,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtmlRdfa,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myRdfParserHtmlScript,
  https___linkedsoftwaredependencies_org_bundles_npm_rdf_parse__1_0_0_config_config_default_json_myHttpFetcher
]
});
module.exports = urn_comunica_my;

